<template>
  <BtnToggle 
    class="btn-tool-font-awesome"
    :title="'Font Awesome'"
    @click="chooseFontAwesome"
  >
    <i class="mce-ico mce-i-font-awesome-o"></i>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";

export default {
  components: {
    BtnToggle,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
  },
  methods: {
    chooseFontAwesome() {
      this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: true });
      this.$store.dispatch("designIframe/modals/setModal", {
        modal_id: "modal-fontawesome",
        payload: {},
        callback:{
          onSubmit: (value) => { 
            this.addFontAwesome(value)
          },
          onClose: () => {
            this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: false });
          },
        },
      });
    },
    addFontAwesome(value) {
      if (!value) return;
      const selection = this.texteditor.editor.getSelection();
      let content = value ? value.icon.html : null;
      this.texteditor.editor.insertEmbed(selection.index + selection.length, 'font-awesome', content);
      if (selection.length > 0) {
        this.texteditor.editor.deleteText(selection);
      }
      this.texteditor.editor.setSelection(selection.index + 1, 0);
    },
  },
}
</script>
<style lang="scss">
.btn-tool-font-awesome {
  display: flex;
  justify-content: center;
  align-items: center;
  i.mce-i-font-awesome-o {
    font-size: 16px;
    width: 16px;
    height: 16px;
    display: flex;
    position: relative;
    &:before {
      content: "\f2b4";
      font-family: 'Font Awesome 5 Brands';
      font-style: normal;
      font-weight: normal;
      text-decoration: inherit;
      font-size: 16px;
      position: absolute;
      top: -2px;
      left: 0;
      width: 16px;
      height: 16px;
    }
  }
}
</style>
